import { useQuery } from '@tanstack/react-query';
import { useSite } from '../../../../context/page-context';
import { useAccountApi } from '../../hooks/use-settings-api';

const QK_ACCOUNT_GET_DEEP_LINKS = (teamId: number | undefined) =>
  ['account-get-deep-links', teamId] as const;

export function useGetDeepLinks() {
  const { accountApi } = useAccountApi();
  const { teamId } = useSite();

  return useQuery({
    queryKey: QK_ACCOUNT_GET_DEEP_LINKS(teamId),
    queryFn: () => accountApi.team(teamId).getDeepLinks(),
    retry: false,
  });
}
